import { Plugin } from 'prosemirror-state';
import { Decoration, DecorationSet } from 'prosemirror-view';
export default (function () {
  var placeholderText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return new Plugin({
    props: {
      decorations: function decorations(state) {
        var decorations = [];

        var decorate = function decorate(node, pos) {
          if (node.type.isBlock && node.childCount === 0) {
            decorations.push(Decoration.node(pos, pos + node.nodeSize, {
              class: 'empty-node',
              'data-placeholder': placeholderText
            }));
          }
        };

        state.doc.descendants(decorate);
        return DecorationSet.create(state.doc, decorations);
      }
    }
  });
});